/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";

import { VApplication } from "../application/index";
import { LIKE_ASSET  } from "../pages/ProductDetail/graphql/like-asset.mutation";

const SERVICE_NAME = "likes.service";
const { LoggerModule } = require("@vlinder-web/logger-module-react");
const log: any = LoggerModule.getInstance();

const is = require("is_js");

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class LikeService {
    name = SERVICE_NAME;
    constructor() {
        this.report();
    }
    async init() {}

    async handleLikes(id:string, tokenGroup:string) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("api-gateway");
        console.log('likes service called', );
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: LIKE_ASSET,
                    variables: {
                        input:{
                            tokenId: id,
                            tokenGroup:tokenGroup
                        }
                    },
                });
                log.info(SERVICE_NAME, "handleLikes: ", res);
                return res?.data;
            }
        } catch (err:any) {
            log.error("error in get handleLikes", err);
            // throw Error(`${err?.message}`)
            return {
                error: err?.message,
            };
        }
    }

    private report() {
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
        log?.info(SERVICE_NAME, "Module Report");
        log?.info(SERVICE_NAME, "⦿ Name: " + this.name);
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
    }
}
